








import { Prop, Component, Vue } from "vue-property-decorator";
import EstimateRow from "./EstimateRow.vue";

@Component({
  components: {
    EstimateRow
  }
})
export default class EstimateHeader extends Vue {
  @Prop({ required: true }) fields!: string[];
}
